const home = {
    tagLine: "Helps you lose fat, build muscle and feel great WITHOUT giving up your personal life!",
    offer: "I offer personalized 1-on-1 online coaching subscriptions and 4 week training and nutrition plans!",
    button: "CHANGE YOUR LIFE"
}

export default home;